import { ChargingPaymentMethod } from '@/types/Payment'
import { StartChargingState, StartChargingStep } from './types'

export const STEP_ORDER: StartChargingStep[] = [
  StartChargingStep.PENDING_BALANCE,
  StartChargingStep.AMOUNT,
  StartChargingStep.PAYMENT_METHOD,
  StartChargingStep.CONFIRMATION,
  StartChargingStep.PROCESS_PAYMENT,
]

export type Action =
  | { type: 'SET_AMOUNT'; payload: number }
  | { type: 'SET_PAYMENT_METHOD'; payload: { method: ChargingPaymentMethod | null; cardId?: number } }
  | { type: 'SET_PROCESSING'; payload: boolean }
  | { type: 'GO_TO_STEP'; payload: StartChargingStep }
  | { type: 'GO_BACK'; payload: { hasPendingBalance: boolean } }
  | { type: 'GO_FORWARD' }
  | { type: 'RESET'; payload: { initialStep: StartChargingStep } }
  | { type: 'SET_USE_WALLET_BALANCE'; payload: boolean }

export const createInitialState = (initialStep: StartChargingStep): StartChargingState => ({
  currentStep: initialStep,
  amount: null,
  paymentMethod: null,
  selectedCardId: null,
  isProcessing: false,
  useWalletBalance: null,
})

export const startChargingReducer = (state: StartChargingState, action: Action): StartChargingState => {
  switch (action.type) {
    case 'SET_AMOUNT': {
      return {
        ...state,
        amount: action.payload,
      }
    }

    case 'SET_PAYMENT_METHOD':
      return {
        ...state,
        paymentMethod: action.payload.method,
        selectedCardId: action.payload.cardId ?? null,
      }

    case 'SET_PROCESSING':
      return {
        ...state,
        isProcessing: action.payload,
      }

    case 'SET_USE_WALLET_BALANCE':
      return {
        ...state,
        useWalletBalance: action.payload,
      }

    case 'GO_TO_STEP':
      return {
        ...state,
        currentStep: action.payload,
      }

    case 'GO_BACK': {
      const currentIndex = STEP_ORDER.indexOf(state.currentStep)
      if (currentIndex <= 0) return state

      const prevIndex = currentIndex - 1
      const prevStep = STEP_ORDER[prevIndex]

      if (prevStep === StartChargingStep.PENDING_BALANCE && !action.payload.hasPendingBalance) {
        return state
      }

      return {
        ...state,
        currentStep: prevStep,
      }
    }

    case 'GO_FORWARD': {
      const currentIndex = STEP_ORDER.indexOf(state.currentStep)
      if (currentIndex >= STEP_ORDER.length - 1) return state

      return {
        ...state,
        currentStep: STEP_ORDER[currentIndex + 1],
      }
    }

    case 'RESET':
      return createInitialState(action.payload.initialStep)

    default:
      return state
  }
}
